import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import styles from "./Seprator.module.scss";

export default ({ noMargin = false }) => (
  <div className={formatClassNames(styles.container, noMargin && styles.noMargin)} />
);
